import { render, staticRenderFns } from "./create-or-edit-role.vue?vue&type=template&id=7e8f09d1&scoped=true"
import script from "./create-or-edit-role.vue?vue&type=script&lang=js"
export * from "./create-or-edit-role.vue?vue&type=script&lang=js"
import style0 from "./create-or-edit-role.vue?vue&type=style&index=0&id=7e8f09d1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8f09d1",
  null
  
)

export default component.exports